// src/services/permissions/permissionHelpers.js
// Permission checking and validation utilities

import { ROLES, PERMISSION_LEVELS, ROLE_HIERARCHY } from '../constants/roleConstants';

/**
 * Check if user has permission for an action based on role hierarchy
 * @param {string} userRole - User's current role
 * @param {string} requiredRole - Required role for the action
 * @returns {boolean} Whether user has permission
 */
export const hasPermission = (userRole, requiredRole) => {
    const userLevel = ROLE_HIERARCHY[userRole] || 0;
    const requiredLevel = ROLE_HIERARCHY[requiredRole] || 0;
    return userLevel >= requiredLevel;
};

/**
 * Check if user has admin access (Super Admin, Creator, or Support)
 * @param {string} userRole - User's current role
 * @returns {boolean} Whether user has admin access
 */
export const hasAdminAccess = (userRole) => {
    return userRole === ROLES.SUPER_ADMIN || 
           userRole === ROLES.CREATOR || 
           userRole === ROLES.SUPPORT;
};

/**
 * Check if user is creator or super admin
 * @param {string} userRole - User's current role
 * @returns {boolean} Whether user is creator or super admin
 */
export const isCreatorOrSuperAdmin = (userRole) => {
    return userRole === ROLES.CREATOR || userRole === ROLES.SUPER_ADMIN;
};

/**
 * Convert permission level string to integer (for Dataroom)
 * @param {string} permissionType - Permission type string
 * @returns {number} Permission level integer
 */
export const getPermissionValue = (permissionType) => {
    if (!permissionType) return PERMISSION_LEVELS.NONE;
    const type = String(permissionType).toLowerCase();
    if (type === 'download') return PERMISSION_LEVELS.DOWNLOAD;
    if (type === 'print') return PERMISSION_LEVELS.PRINT;
    if (type === 'view') return PERMISSION_LEVELS.VIEW;
    return PERMISSION_LEVELS.NONE;
};
